export const ROOT = '/';

// Kinnect
export const KINNECT_PAGE_PATH = '/kinnect';
export const KINNECT_EMAIL_CONFIRMATION_PAGE_PATH = `${KINNECT_PAGE_PATH}/confirmation`;
export const KINNECT_PASSWORD_RESET_PAGE_PATH = `${KINNECT_PAGE_PATH}/reset-password`;
